<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollable max-width="500px")
    yz-card
      yz-dialog-normal-header(title="Add logs note" @close="onClose")

      yz-dialog-normal-content.px-6.py-6
        .text-neutral-700
          // Activity log section
          yz-card.pa-4.mb-6(outlined)
            .d-flex.align-start.gap-3
              // Icon container with rounded background
              .d-flex.align-center.justify-center.flex-shrink-0(style="width: 24px; height: 24px; background-color: var(--yz-neutral-300); border-radius: 12px;")
                yz-icon(size="14px" color="yz-neutral-500") {{ icon }}
              .flex-grow-1
                .yz-medium-body-sm.text-neutral-700.mb-1 {{ activity }}
                .yz-regular-body-xs.text-neutral-500 {{ date }}

          // Note field
          v-form(ref="form" v-model="formValid")
            .yz-medium-body-sm.text-neutral-700.mb-2 Note
            yz-textarea(v-model.trim="note" placeholder="Enter note" rows="4" background-color="white" width="full" required, required-error-message="Note is required")

      yz-dialog-normal-actions(save-label="Save" cancel-label="Cancel" :disable-save="!canSave" :loading="isSaving" @save="onSave" @cancel="onCancel")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    logId: {
      type: [String, Number],
      required: true
    },
    activity: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    parentNote: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      note: '',
      formValid: false,
      isSaving: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    canSave() {
      return this.formValid && this.note && this.note.trim().length > 0
    }
  },
  mounted() {
    this.note = this.parentNote
  },
  methods: {
    ...mapActions(['showMessage']),
    async onSave() {
      if (!this.$refs.form.validate()) {
        await this.showMessage(['error', 'Please fill in the required fields.'])
        return
      }

      this.isSaving = true
      try {
        await this.$axios.patch(`/actions/${this.logId}`, {
          note: this.note
        })

        this.$emit('updated')

        await this.showMessage(['success', 'Note saved successfully'])
      } catch (error) {
        console.error('Error saving note:', error)
        await this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isSaving = false
      }
    },
    onCancel() {
      this.$emit('canceled')
    },
    onClose() {
      this.$emit('canceled')
    }
  }
}
</script>

<style scoped>
.gap-3 {
  gap: 12px;
}
</style>
